import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { OverrideType, PassengerType } from 'src/app/core/enums/enums';
import {
  TaxSummary,
  Price,
  FareSummary,
  FixedChargeSummary
} from 'src/app/core/models/cancellation.model';

@Component({
  selector: 'app-general-fare',
  templateUrl: './general-fare.component.html',
  styleUrls: ['./general-fare.component.scss']
})
export class GeneralFareComponent implements OnChanges {
  @Input() taxes: TaxSummary[] | FareSummary[] | FixedChargeSummary[] = [];
  @Input() hasAmountColor: boolean;
  @Input() taxAmount: Price;
  @Input() title: string;
  @Input() priceOnBottom = false;
  @Input() noReefundableTaxesTooltip = '';
  @Input() type: string;
  expand = false;

  ngOnChanges() {
    if (this.type === OverrideType.FixedCharges) {
      this.removeInfants(this.taxes);
    }
  }

  toggleDetail() {
    this.expand = !this.expand;
  }

  removeInfants(taxes: any[]) {
    this.taxes = taxes?.filter((taxe) => taxe?.passengerType !== PassengerType.Infant);
  }
}
